import './vendor/jquery-3.6.0.js';
import './vendor/yandex-map.js';
import './vendor/focus-visible.js';
import './vendor/parallax.min.js';
